import React from 'react'
import { connect } from 'react-redux'
import OrderActions from '../../Redux/OrderRedux'
import find from 'lodash/find'
import Select from 'react-select'

class ChangeStatusModal extends React.Component {
  constructor (props) {
    super(props)
    this.orderStatus = [
      { value: 'checkout', label: 'CHECKOUT' },
      { value: 'payment-pending', label: 'PENDING' }
    ]
    let { order_number, status, unique_number } = props.detail
    let options = []
    this.orderStatus.map((status, i) => {
      options.push(status)
      return options
    })
    this.options = options
    status = find(this.options, function (i) { return i.value === status })
    this.state = {
      order_number,
      status,
      unique_number
    }
  }

  _uniqueChange = (event, field) => {
    let val = event.target.value
    let form = { ...this.state }
    form.unique_number = val
    this.setState(form)
  }

  _submit = (event) => {
    event.preventDefault()
    const data = {
      form: {
        order_number: this.state.order_number,
        status: this.state.status.value,
        unique_number: this.state.unique_number
      }
    }
    this.props.closeModal()
    this.props.submit(data)
  }

  render () {
    const { order, detail } = this.props

    return (
      <form onSubmit={(event) => this._submit(event)} className='section' style={{ width: '30vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Edit Status <div className='badge badge-secondary ml-2'>{detail.order_number}</div>
            {
              (order.fetching || order.processing) &&
              <div className='badge badge-info ml-2'>{order.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        <div className='form-group' style={{ position: 'relative' }}>
          <label className='control-label'>Status</label>
          <Select
            options={this.options}
            value={this.state.status}
            required
            onChange={(status) => this.setState({ status })}
          />
          <input
            value={this.state.status}
            required
            onChange={() => null} style={{ position: 'absolute', zIndex: '-1', top: '50%', left: '30%' }}
          />
        </div>
        <div className='form-group' style={{ position: 'relative' }}>
          <label className='control-label'>Unique Number</label>
          <input
            type='number'
            min='0'
            step='any'
            className='form-control'
            value={this.state.unique_number}
            onChange={(event) => this._uniqueChange(event, 'unique_number')}
          />
        </div>
        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
          <button type='submit' className='btn btn-lg btn-primary'>Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  order: state.order
})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(OrderActions.orderCheckoutRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ChangeStatusModal)



// WEBPACK FOOTER //
// ./src/Containers/Order/ChangeStatusModal.js